import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advisors',
  templateUrl: './advisors.component.html',
  styleUrls: ['./advisors.component.css']
})
export class AdvisorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
